module.exports = __webpack_public_path__ + "img/HeaderLayoutC.95d16242.jpg";